// utils/killSwitch.js
export const isPrivacyModeActive = () => {
  return localStorage.getItem("vpn") === "on";
};

export const isKillSwitchEnabled = () => {
  return localStorage.getItem("killSwitch") === "enabled";
};

export const shouldBlockAccess = () => {
  const killSwitchOn = isKillSwitchEnabled();
  const privacyModeOn = isPrivacyModeActive();

  // Block access if Kill Switch is ON but Privacy Mode is OFF
  return killSwitchOn && !privacyModeOn;
};

export const getKillSwitchBlockingMessage = () => {
  return "Access restricted. Please enable Privacy Mode to continue watching.";
};
